const article = {
  "article.title": "Guide du Basetao Spreadsheet : définition et utilisation",
  "article.meta.description":
    "Découvrez ce qu'est un Basetao Spreadsheet, ce qu'il contient et comment l'utiliser pour comparer produits, vendeurs et catégories lors de vos commandes via Basetao.",
  "article.breadcrumb": "Guide du Spreadsheet",
  "article.h1": "Guide du Basetao Spreadsheet : définition et utilisation",

  "article.author": "Par :",
  "article.author.name": "Équipe éditoriale Basetao Sheet",
  "article.published": "Publié le :",
  "article.updated": "Mis à jour le :",
  "article.date": "18 août 2026",

  "article.intro":
    "Un Basetao Spreadsheet est une liste partagée et organisée de liens produits, de catégories, de vendeurs et de notes que les acheteurs utilisent pour trouver et comparer des articles commandés via Basetao. En bref, il transforme un vaste catalogue dispersé en un point de départ ordonné que vous pouvez filtrer, trier et partager. Ce guide explique ce qu'il contient généralement, comment le lire et comment l'utiliser pour acheter plus efficacement.",

  "article.toc.title": "Sur cette page",
  "article.toc.1": "Qu'est-ce qu'un Basetao Spreadsheet ?",
  "article.toc.2": "Ce que vous y trouverez",
  "article.toc.3": "Comment utiliser un Basetao Spreadsheet",
  "article.toc.4": "Pourquoi les acheteurs s'y appuient",
  "article.toc.5": "Conseils pour en tirer le meilleur parti",
  "article.toc.6": "Questions fréquentes",

  "article.s1.h2": "Qu'est-ce qu'un Basetao Spreadsheet ?",
  "article.s1.p1":
    "Basetao est un agent d'achat qui aide les acheteurs hors de Chine à commander sur des places de marché comme Taobao, Weidian et 1688, puis à se faire livrer à l'international. Un Basetao Spreadsheet est une ressource complémentaire : une liste déjà construite et partagée, contenant des liens vers des produits précis, leurs catégories, leurs vendeurs et des notes utiles.",
  "article.s1.p2":
    "Considérez-le comme une carte organisée du catalogue plutôt que le catalogue lui-même. Au lieu de parcourir des centaines de pages, vous partez d'un ensemble d'articles que d'autres acheteurs ont déjà localisés et, souvent, vérifiés. Cela vous fait gagner du temps et vous donne une manière plus ciblée de comparer vos options.",

  "article.s2.h2": "Ce que vous trouverez dans un Basetao Spreadsheet",
  "article.s2.p1":
    "Les feuilles de calcul varient, mais la plupart des plus soignées reposent sur quelques colonnes cohérentes. Voici ce que signifie chaque colonne et en quoi elle aide.",
  "article.s2.table.c1": "Colonne",
  "article.s2.table.c2": "Ce qu'elle indique",
  "article.s2.table.c3": "Pourquoi c'est utile",
  "article.s2.r1.c1": "Produit",
  "article.s2.r1.c2": "L'article précis et son lien",
  "article.s2.r1.c3": "Accéder directement à l'article voulu",
  "article.s2.r2.c1": "Catégorie",
  "article.s2.r2.c2": "Le groupe auquel l'article appartient",
  "article.s2.r2.c3": "Filtrer chaussures, hoodies, sacs et plus",
  "article.s2.r3.c1": "Vendeur",
  "article.s2.r3.c2": "Le nom de la boutique ou du vendeur",
  "article.s2.r3.c3": "Repérer des vendeurs fiables connus",
  "article.s2.r4.c1": "Notes / QC",
  "article.s2.r4.c2": "Contrôle qualité et autres remarques",
  "article.s2.r4.c3": "Éviter les problèmes avant de commander",

  "article.s3.h2": "Comment utiliser un Basetao Spreadsheet",
  "article.s3.p1":
    "Aucun outil particulier n'est nécessaire pour utiliser une feuille de calcul. Suivez ces quatre étapes pour passer d'une liste à une commande sereine.",
  "article.s3.step1.title": "1. Commencez par une catégorie",
  "article.s3.step1.text":
    "Filtrez la feuille selon la catégorie qui vous intéresse — chaussures, t-shirts, vestes, sacs ou accessoires — pour ne voir que les lignes pertinentes.",
  "article.s3.step2.title": "2. Consultez les notes",
  "article.s3.step2.text":
    "Lisez les notes sur les vendeurs et le contrôle qualité attachées à un produit. Elles soulignent souvent des détails de taille, de qualité ou d'expédition.",
  "article.s3.step3.title": "3. Ouvrez le lien produit",
  "article.s3.step3.text":
    "Utilisez le lien produit pour voir l'article sur le site principal et confirmer le prix, les photos et la disponibilité avant de vous engager.",
  "article.s3.step4.title": "4. Comparez avant d'acheter",
  "article.s3.step4.text":
    "Mettez deux ou trois articles similaires côte à côte pour comparer vendeurs et détails, puis choisissez celui qui vous convient le mieux.",

  "article.s4.h2": "Pourquoi les acheteurs s'appuient sur une feuille de calcul",
  "article.s4.p1":
    "La raison principale est simple : une feuille de calcul élimine l'essentiel des frictions de navigation. Au lieu d'ouvrir page après page en essayant de retenir ce que vous avez vu, vous obtenez une vue unique et triable des produits, catégories, vendeurs et notes. C'est particulièrement utile quand on débute avec un agent d'achat, car la liste offre un point de départ déjà organisé, et les notes peuvent vous éviter des erreurs courantes comme négliger la taille ou choisir un vendeur peu fiable.",

  "article.s5.h2": "Conseils pour en tirer le meilleur parti",
  "article.s5.p1": "Gardez ces habitudes en tête pour que la feuille de calcul travaille davantage pour vous.",
  "article.s5.t1": "Vérifiez avant de commander — liens et prix peuvent changer, confirmez toujours l'article sur la page produit.",
  "article.s5.t2": "Utilisez les catégories pour affiner votre recherche au lieu de faire défiler toute la liste.",
  "article.s5.t3": "Ajoutez vos propres notes au fur et à mesure pour garder votre sélection organisée.",
  "article.s5.t4": "Mettez en favoris les articles qui vous plaisent pour y revenir plus tard.",

  "article.s6.h2": "Questions fréquentes",
  "article.s6.q1": "Faut-il un compte Basetao pour utiliser la feuille de calcul ?",
  "article.s6.a1":
    "Non. Vous pouvez lire et utiliser la feuille de calcul librement. Un compte n'est nécessaire que si vous décidez de commander via un agent d'achat ou le site principal.",
  "article.s6.q2": "Les produits de la feuille sont-ils toujours disponibles ?",
  "article.s6.a2":
    "La disponibilité, les prix et les détails des vendeurs peuvent évoluer. La feuille de calcul est un bon point de départ, mais confirmez toujours les détails actuels sur la page produit.",

  "article.s7.h2": "En résumé",
  "article.s7.p1":
    "Un Basetao Spreadsheet est l'un des moyens les plus simples d'acheter via un agent d'achat sans repartir de zéro. En vous offrant une liste structurée de produits, catégories, vendeurs et notes, il vous aide à gagner du temps, à comparer plus facilement et à faire des choix plus sûrs. Commencez par une catégorie, consultez les notes et vérifiez la page produit avant d'acheter.",

  "article.cta.text": "Prêt à parcourir ? Explorez tout le catalogue sur le site principal.",
  "article.cta.button": "Acheter maintenant",
  "article.backHome": "Retour à l'accueil",
};

export default article;